import React from 'react';

const Spinner = (props) => {

  return (
    <div className="App">
      <div id="quote-box">
        <div className="spinner"></div>
      </div>
    </div>
  )
}

export default Spinner;